import React, { Component } from 'react';
import './iamExKeContent.css';
import IamExTableRow from './iamExKeTableRow/iamExKeTableRow.js';

class IamExKeContent extends Component {

  state = {

  };

  componentDidMount() {

  };

  render() {

    return (
      <div className="IamExKeContentPage">
        <div className="KeyTableContainer">
          <table className="KeyTable">
            <thead>
              <tr>
                <th>User</th>
                <th>Account</th>
                <th>Access Key ID</th>
                <th>Created</th>
                <th>Last Used</th>
                <th>State</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {this.props.users.map(user => {
                return user.AccessKeys.map(accessKey => {
                  return <IamExTableRow key={accessKey.AccessKeyId} user={user} iamAccessKey={accessKey}/>;
                });
              })}
            </tbody>
          </table>
        </div>
      </div>
    );

  };

};

export default IamExKeContent;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExKeys/iamExKeContent/iamExKeContent.js